import { defineMessages } from 'react-intl';

export const trackingHistorySectionMessages = defineMessages({
  sectionTitle: {
    defaultMessage: 'Tracking',
    id: '/VcmCo',
    description: 'Title of the tracking history card in the freight details view',
  },
  stepPendingPickup: {
    defaultMessage: 'Pending Pickup',
    id: 'xri9RQ',
    description: 'First tracking stepper step, before the carrier has picked up the shipment',
  },
  stepInTransit: {
    defaultMessage: 'In Transit',
    id: 'FkrHQO',
    description: 'Second tracking stepper step, while the shipment is moving',
  },
  stepDelivered: {
    defaultMessage: 'Delivered',
    id: '1oYiWg',
    description: 'Final tracking stepper step, after the shipment has been delivered',
  },
  proNumberLabel: {
    defaultMessage: 'PRO Number',
    id: 'bGWaQH',
    description: 'Label for the carrier PRO number tracking link',
  },
  updatesTitle: {
    defaultMessage: 'Updates',
    id: 'rWd2a9',
    description: 'Title of the accordion listing tracking update events',
  },
  lastUpdated: {
    defaultMessage: 'Updated: {date}',
    id: 'QTpzUl',
    description: 'Line showing when tracking history was last refreshed',
  },
});
